<template>
  <div class="demonstration-base-form-page">
    <el-form
      ref="demonstrationBaseForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="示范基地名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入示范基地名称"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="formData.address" placeholder="请输入地址" rows="2" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson">
        <el-input v-model="formData.contactPerson" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="formData.contactPhone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="是否存在" prop="isExist">
        <el-radio-group v-model="formData.isExist">
          <el-radio label="1">存在</el-radio>
          <el-radio label="0">不存在</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否六有标准" prop="isSixStandards">
        <el-radio-group v-model="formData.isSixStandards">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="经度" prop="longitude">
            <el-input-number
              v-model="formData.longitude"
              :min="-180"
              :max="180"
              :step="0.000001"
              :precision="6"
              placeholder="请输入经度"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纬度" prop="latitude">
            <el-input-number
              v-model="formData.latitude"
              :min="-90"
              :max="90"
              :step="0.000001"
              :precision="6"
              placeholder="请输入纬度"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="formData.remark" placeholder="请输入备注" rows="3" type="textarea"></el-input>
      </el-form-item>

      <div class="form-button-area">
        <el-button type="primary" @click="handleSubmit('demonstrationBaseForm')">保存</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { DemonstrationBaseController } from '@/api';

export default {
  name: 'DemonstrationBaseForm',
  props: {
    // 编辑模式
    editMode: {
      type: Boolean,
      default: false
    },
    // 示范基地数据
    demonstrationBase: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // 表单数据
      formData: {
        id: null,
        name: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        isExist: null,
        isSixStandards: null,
        longitude: null,
        latitude: null,
        remark: ''
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入示范基地名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        isExist: [
          { required: true, message: '请选择是否存在', trigger: 'change' }
        ],
        isSixStandards: [
          { required: true, message: '请选择是否六有标准', trigger: 'change' }
        ],
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
          { type: 'number', min: -180, max: 180, message: '经度范围在 -180 到 180 之间', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
          { type: 'number', min: -90, max: 90, message: '纬度范围在 -90 到 90 之间', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    // 监听demonstrationBase变化
    demonstrationBase: {
      handler (newVal) {
        this.formData = Object.assign({}, newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 提交表单
    handleSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 提交数据
          this.submitData();
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });
    },

    // 提交数据
    submitData () {
      let params = {
        demonstrationBaseDto: {
          ...(this.editMode ? this.formData : {
            name: this.formData.name,
            address: this.formData.address,
            contactPerson: this.formData.contactPerson,
            contactPhone: this.formData.contactPhone,
            isExist: this.formData.isExist,
            isSixStandards: this.formData.isSixStandards,
            longitude: this.formData.longitude,
            latitude: this.formData.latitude,
            remark: this.formData.remark
          })
        }
      };

      this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const savePromise = this.editMode
        ? DemonstrationBaseController.update(this, params)
        : DemonstrationBaseController.add(this, params);

      savePromise.then(res => {
        this.$message.success(this.editMode ? '更新成功' : '新增成功');
        this.$emit('save');
      }).catch(e => {
        this.$message.error(e.msg || (this.editMode ? '更新失败' : '新增失败'));
      }).finally(() => {
        this.$loading().close();
      });
    },

    // 取消
    handleCancel () {
      this.$emit('cancel');
      this.resetForm();
    },

    // 重置表单
    resetForm () {
      this.$refs['demonstrationBaseForm'].resetFields();
      this.formData = {
        id: null,
        name: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        isExist: null,
        isSixStandards: null,
        longitude: null,
        latitude: null,
        remark: ''
      };
    }
  }
};
</script>

<style scoped>
.demonstration-base-form-page {
  padding: 10px;
}

.form-button-area {
  margin-top: 20px;
  text-align: center;
}
</style>
